import createAction from './';

export const OPEN_ARCHIVE = createAction('OPEN_ARCHIVE');
export const CLOSE_ARCHIVE = createAction('CLOSE_ARCHIVE');

export const openArchive = () => ({ type: OPEN_ARCHIVE });
export const closeArchive = () => ({ type: CLOSE_ARCHIVE });
